export Camelizer from './Camelizer'
export * as attachments from './attachments'
export * as formatDob from './dobFormatter'
export * as email from './email'
export generateComparator from './generateComparator'
export isConfigurableProperty from './isConfigurableProperty'
export jsonCloneDeep from './jsonCloneDeep'
export * as phone from './phone'
export replaceKey from './replaceKey'
export replaceKeys from './replaceKeys'
export SortedArray from './SortedArray'
export urlEncodedTaggedString from './urlEncodedTaggedString'
export Validator from './Validator'

export function arrayWrapBound() {
  return arrayWrap(this)
}

export function arrayWrap(thing) {
  return Array.isArray(thing) ? thing : thing !== undefined && thing !== null ? [thing] : []
}
